// @ts-strict-ignore
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { EndpointQueryKey, FilteredDashboardApiEndpointKeys } from "../types";
import type { dashboardApiEndpoints } from "../dashboardApiEndpoints";
import type { GetFakeThingProps } from "./types";
import type { RemoveFirstArgument } from "@lib/typeHelpers";

/**
 * A fake fetcher function maker, for use in storybook
 *
 * @example
 * export const getFakeDeveloper = (maker: (companyId: string) => Partial<Developer>) =>
 *  getFakeThing({
 *    cacheKey,
 *    baseFakeThing: fakeDeveloper,
 *    maker,
 *  });
 */
export const getFakeLoadingGetFetcherFunction = <
  PayloadShape,
  CacheKey extends FilteredDashboardApiEndpointKeys,
  Args extends RemoveFirstArgument<Parameters<(typeof dashboardApiEndpoints)[CacheKey]["GET"]>[0]["queryKey"]>,
>({
  cacheKey,
}: GetFakeThingProps<PayloadShape, CacheKey>): (({
  queryKey: [, ...rest],
  signal,
}: EndpointQueryKey<CacheKey, Args>) => Promise<PayloadShape>) =>
  reactQueryFetcherAdapter(cacheKey, async (): Promise<PayloadShape> => {
    return new Promise(() => {});
  });
